import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./Components/shared/AppModals.css";
import App from "./App.jsx";

/**
 * Desregista service workers legados e limpa Cache Storage.
 * SW antigo podia servir index.html (200 HTML) em /sca/*, /adm/*, etc.
 */
function purgeLegacyServiceWorkers() {
  if (typeof window === "undefined") return;
  if ("serviceWorker" in navigator) {
    void navigator.serviceWorker.getRegistrations().then((regs) => {
      for (const reg of regs) {
        void reg.unregister();
      }
    });
  }
  if (typeof caches !== "undefined" && caches.keys) {
    void caches.keys().then((keys) => {
      for (const key of keys) {
        void caches.delete(key);
      }
    });
  }
}

purgeLegacyServiceWorkers();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
